function text(value: string | undefined): string {
  return value?.trim() || "";
}

function index(value: string | undefined): number | undefined {
  if (value === undefined || value === "") return undefined;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : undefined;
}

export function productSelectionInput(link: Element): ProductEventInput | null {
  const card = link.closest<HTMLElement>("[data-product-event-card]");
  if (!card) return null;
  const experiment = link.closest<HTMLElement>("[data-event-experiment-id][data-event-experiment-group]");
  const pair = link.closest<HTMLElement>("[data-purchase-experiment-pair]");
  const productId = text(card.dataset.eventProductId);
  const title = text(card.dataset.eventProductTitle);
  const listId = text(pair?.dataset.purchaseExperimentPair) || text(card.dataset.eventListId);
  const listName = text(card.dataset.eventListName);
  const position = index(card.dataset.eventIndex);
  if (!productId || !title || !listId || !listName || position === undefined) return null;

  return {
    product: { id: productId, title },
    placement: text(card.dataset.eventPlacement) || "card_product",
    origin: text(card.dataset.eventOrigin) || "unknown",
    originPlacement: text(card.dataset.eventPlacement) || "card_product",
    originListId: listId,
    originListName: listName,
    originIndex: position,
    listId,
    listName,
    index: position,
    experiment: experiment ? {
      id: text(experiment.dataset.eventExperimentId),
      group: text(experiment.dataset.eventExperimentGroup),
    } : undefined,
  };
}

export function bootstrapProductInteractions(): void {
  document.addEventListener("click", event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const link = target.closest("[data-product-event-select]");
    if (!link) return;
    const input = productSelectionInput(link);
    if (input) window.__tracking?.trackProductEvent("select_item", input);
  }, { capture: true });
}
